/* AFF Spain 2026 countdown — safe for all templates */
(function () {
  function initCountdown(root) {
    if (!root || root.__affTimerInit) return;
    root.__affTimerInit = true;

    var targetStr = root.getAttribute('data-countdown-target');
    if (!targetStr) return;
    var target = new Date(targetStr);
    if (isNaN(target)) return;

    var daysEl = root.querySelector('#days');
    var hoursEl = root.querySelector('#hours');
    var minutesEl = root.querySelector('#minutes');
    if (!daysEl || !hoursEl || !minutesEl) return;

    function update() {
      var now = new Date();
      var diff = target - now;

      if (diff <= 0) {
        daysEl.textContent = '0';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        clearInterval(timer);
        return;
      }

      var totalMinutes = Math.floor(diff / 60000);
      var days = Math.floor(totalMinutes / 1440);
      var hours = Math.floor((totalMinutes % 1440) / 60);
      var minutes = totalMinutes % 60;

      daysEl.textContent = String(days);
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
    }

    update();
    var timer = setInterval(update, 60000);
  }

  function tryInit() {
    var root = document.getElementById('aff-2026');
    if (root) initCountdown(root);
  }

  // Run on normal loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  // Handle theme navigations/section reloads
  document.addEventListener('shopify:section:load', tryInit);
  document.addEventListener('page:load', tryInit);
  document.addEventListener('turbo:load', tryInit);
  document.addEventListener('pageshow', tryInit);
})();
